"use client";

import { useTranslations } from "next-intl";
import { Button } from "./Button";
import { Modal } from "./Modal";

export interface ConfirmDialogProps {
  open: boolean;
  title: React.ReactNode;
  description?: React.ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
  loading?: boolean;
  onConfirm: () => void;
  onClose: () => void;
  children?: React.ReactNode;
  /** Forwarded to Modal: wrapper classes (e.g. z-index above the lightbox). */
  overlayClassName?: string;
}

/** Confirmation modal for destructive or irreversible actions. */
export function ConfirmDialog({
  open,
  title,
  description,
  confirmLabel,
  cancelLabel,
  danger = false,
  loading = false,
  onConfirm,
  onClose,
  children,
  overlayClassName,
}: ConfirmDialogProps) {
  const t = useTranslations("confirm");
  const tCommon = useTranslations("common");
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      size="sm"
      overlayClassName={overlayClassName}
      footer={
        <>
          <Button variant="ghost" onClick={onClose} disabled={loading}>
            {cancelLabel ?? tCommon("cancel")}
          </Button>
          <Button
            variant={danger ? "danger" : "primary"}
            onClick={onConfirm}
            isLoading={loading}
          >
            {confirmLabel ?? t("confirm")}
          </Button>
        </>
      }
    >
      {description && (
        <p className="text-sm leading-relaxed text-white/65">{description}</p>
      )}
      {children}
    </Modal>
  );
}
